import React, { ReactNode } from "react";

interface GrayBorderBoxProps {
  w?: string;
  h?: string;
  g?: string;
  p?: string;
  m?: string;
  children?: ReactNode;
  onClick?: () => void; // Agregado onClick como opcional
  style?: React.CSSProperties; // Soporte para estilos en línea
}

export const GrayBorderBox: React.FC<GrayBorderBoxProps> = ({
  w,
  h,
  g,
  p,
  m,
  children,
  onClick, // Incluido onClick
}) => {
  return (
    <div
     //className="flex flex-col justify-center items-center"
      className="flex flex-col "
      style={{
        width: w || "50%",
        height: h || "50%",
        margin: m || "1%",
        gap: g || "1%",
        borderRadius: "36px",
        padding: p || "16px",
        border: "16px solid #EAEBF0",
        opacity: 1,
        cursor: onClick ? "pointer" : "default", // Cambia el cursor si hay onClick
      }}
      onClick={onClick} // Asigna el evento onClick
    >
      {children}
    </div>
  );
};

interface InvisibleBoxProps {
  w?: string;
  h?: string;
  g?: string;
  posTop?: string;
  posLeft?: string;
  children?: ReactNode;
}

export const InvisibleExternalBox: React.FC<InvisibleBoxProps> = ({
  w,
  h,
  g,
  posTop,
  posLeft,
  children,
}) => {
  return (
    <div
      className="flex flex-col justify-between items-center m-0 p-0"
      style={{
        width: w || "50%",
        height: h || "50%",
        gap: g || "0",
        position: "absolute",
        top: posTop || "50%",
        left: posLeft || "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      {children}
    </div>
  );
};

interface InternalBoxProps {
  w?: string;
  h?: string;
  g?: string;
  children?: ReactNode;
  onClick?: () => void;
  cursor?: string;
}

export const InternalLeftBox: React.FC<InternalBoxProps> = ({
  w,
  h,
  g,
  children,
}) => {
  return (
    <div
      className="flex flex-col justify-center"
      style={{
        width: w || "100%",
        height: h || "100%",
        gap: g || "1%",
        justifyContent: "flex-start",
        alignItems: "start",
      }}
    >
      {children}
    </div>
  );
};

export const InternalCenterBox: React.FC<InternalBoxProps> = ({
  w,
  h,
  g,
  children,
  onClick,
  cursor,
}) => {
  return (
    <div
      className="flex flex-col justify-center"
      style={{
        width: w || "100%",
        height: h || "100%",
        gap: g || "0%",
        justifyContent: "center",
        alignItems: "center",
        cursor: cursor || "default",
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};



interface BannerBoxProps {
  backgroundColor: string;
  height: string;
  children?: ReactNode;
}

export const BannerBox: React.FC<BannerBoxProps> = ({
  backgroundColor,
  height,
  children,
}) => {
  return (
    <div
      className="w-full flex items-center justify-between border-b border-gray-300 gap-[16px]"
      style={{
        backgroundColor: backgroundColor,
        height: height,
      }}
    >
      {children}
    </div>
  );
};

interface SideBarBoxProps {
  children?: ReactNode;
  onClose: () => void;
}

export const SideBarBox: React.FC<SideBarBoxProps> = ({
  children,
  onClose,
}) => {
  return (
    <div
      className="fixed top-0 right-0 w-[514px] h-screen overflow-y-auto bg-white z-50 shadow-lg px-[26px] gap-[16px] rounded-l-[24px] rounded-bl-[24px] overflow-x-hidden"
      onClick={onClose}
    >
      {children}
    </div>
  );
};

interface SideBarBookingBoxProps {
  children: ReactNode;
  onClick: () => void;
}

export const SideBarBookingBox: React.FC<SideBarBookingBoxProps> = ({
  children,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className="flex items-center w-[100%px] h-[83px] p-[23px] border rounded-[24px] gap-[16px] cursor-pointer"
      style={{ borderColor: "#EAEBF0" }}
    >
      {children}
    </div>
  );
};

interface SideBarBookingTextBoxProps {
  title: ReactNode;
  subtitle: ReactNode;
}

export const SideBarBookingTextBox: React.FC<SideBarBookingTextBoxProps> = ({
  title,
  subtitle,
}) => {
  return (
    <div className="flex flex-col w-auto h-[37px]">
      {subtitle}
      {title}
    </div>
  );
};

export const PopUpWhiteBox: React.FC<GrayBorderBoxProps> = ({
  w,
  h,
  g,
  p,
  m,
  children,
}) => {
  return (
    <div
      className="flex flex-col w-[346px] h-auto"
      style={{
        margin: m || "1%",
        gap: g || "1%",
        borderRadius: "36px",
        padding: p || "24px",
        backgroundColor: "#FFFFFF",
        opacity: 1,
      }}
    >
      {children}
    </div>
  );
};
